import { Input } from '@mis/sushi-tailwind-react';
import React from 'react';

export const TextDisplay: React.FC<{ type: string; value: Nullable<string>; name?: string; placeholder?: string }> = ({
  type,
  value,
  name,
  placeholder,
}) => {
  return <Input data-testid={type} value={value || ''} viewOnly name={name} placeholder={placeholder} />;
};
